
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.68 3.82V2.18H7.32v1.64h3.36zm5 0c.442 0 .82.17 1.133.508.338.339.507.73.507 1.172V8c0 .443-.169.833-.508 1.172-.312.338-.69.508-1.132.508h-5V8H7.32v1.68h-5c-.468 0-.86-.157-1.172-.47A1.724 1.724 0 01.68 8V5.5c0-.443.156-.833.468-1.172.339-.338.73-.508 1.172-.508h3.32V2.18L7.32.5h3.32l1.68 1.68v1.64h3.36zm-8.36 7.5h3.36v-.82h5.82v3.32c0 .47-.17.873-.508 1.211-.312.313-.703.469-1.172.469H3.18c-.47 0-.873-.156-1.211-.469a1.724 1.724 0 01-.469-1.21V10.5h5.82v.82z","fill":"currentColor"}})])
          )
        }
      }
    